var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonofamiliare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    viewBox: "0 0 33 32",
    width: 33,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    height: 32,
    maskUnits: "userSpaceOnUse",
    width: 33,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.75 0h32v32h-32z",
    fill: "#d9d9d9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.74967 25.3333h4.00003v-6.6667c0-.3778.1278-.6944.3833-.95.2556-.2555.5722-.3833.95-.3833h5.3333c.3778 0 .6945.1278.95.3833.2556.2556.3834.5722.3834.95v6.6667h4v-12l-8-6.00001-8.00003 6.00001zm-2.66666 0v-12c0-.4222.09444-.8222.28333-1.2s.45-.6889.78333-.9333l8.00003-6.00004c.4666-.35556 1-.53333 1.6-.53333s1.1333.17777 1.6.53333l8 6.00004c.3333.2444.5944.5555.7833.9333s.2833.7778.2833 1.2v12c0 .7333-.2611 1.3611-.7833 1.8833s-1.15.7834-1.8833.7834h-5.3334c-.3777 0-.6944-.1278-.95-.3834-.2555-.2555-.3833-.5722-.3833-.95v-6.6666h-2.6667v6.6666c0 .3778-.1277.6945-.3833.95-.2555.2556-.5722.3834-.95.3834h-5.33333c-.73333 0-1.36111-.2612-1.88333-.7834s-.78333-1.15-.78333-1.8833z",
    fill: "#D3135A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonofamiliare);
export default __webpack_public_path__ + "static/media/monofamiliare.6bb798af32c85d93309a1b30765799b8.svg";
export { ForwardRef as ReactComponent };